var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQArrowShortRight = function SvgQArrowShortRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 37 37"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 36.589,
    y: 0.5,
    rx: 18,
    transform: "rotate(90 36.589 .5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198,
    d: "m18.178 11.768 7.303 7.303-7.303 7.304"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 3.198,
    d: "M25.328 19.147h-14.45"
  })));
};
export { SvgQArrowShortRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAzNyAzNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMzYuNTg4OSIgeT0iMC41IiB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHJ4PSIxOCIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMzYuNTg4OSAwLjUpIiBmaWxsPSJub25lIi8+CjxwYXRoIGQ9Ik0xOC4xNzc3IDExLjc2NzZMMjUuNDgxMiAxOS4wNzFMMTguMTc3NyAyNi4zNzQ1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzLjE5NzU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI1LjMyODEgMTkuMTQ2NUwxMC44Nzc2IDE5LjE0NjUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMuMTk3NTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";